import React from 'react';
import './TermsAndConditions.css';

const CareerCoachTerms = () => {
    return (
        <div className="ip-terms-container">
            <h1 className="ip-terms-title">Agreement to Our Terms and Conditions</h1>
            <p className="ip-updated-date">Last Updated 14/01/2025</p>
            <p className="ip-terms-section-content">
                We are The Ideal Pursuits (“Company”, “we”, “us”, “our”).
            </p>

            <div className="ip-terms-section">
                <h2 className="ip-terms-section-title">Terms and Conditions</h2>
                <ol className="ip-terms-section-content">
                    <li>All categories of service mentioned herein can be availed by students pursuing 12th grade, undergraduate or postgraduate degree, and professionals either working or otherwise.</li>
                    <li>This service is solely for the purpose of providing educational and career upskilling consultation. Any information/ideas exchanged between Service Availer and the expert shall be of a recommendatory nature in order to channelise the career path of the service availer.</li>
                    <li>Service availer and experts within the domain of the service must conduct themselves with professionalism, expertise, and integrity during the session.</li>
                    <li>Conversation between experts and users should be strictly educational and career related only. No personal information to be provided.</li>
                    <li>Failure to adhere to the previous point, the website owner takes no responsibility regarding the personal conversations between user and expert.</li>
                    <li>During video calls, complete professionalism, decorum to be maintained. Any violation stipulated as per the terms and conditions set forth herein will lead to immediate termination of the session and profile of the user will be deactivated.</li>
                    <li>Any suggestions related to acquiring a skill related to career in terms of courses or college is subjected to personal choice of the user. The company will not be held accountable for any damage or losses.</li>
                    <li>No guarantees to be made in terms of job or assured success in career. Only opinionated methodology to be adopted which provides service.</li>
                    <li>You will not use the services for any illegal and unauthorized purpose and your use of services should not violate any applicable law or regulation.</li>
                </ol>
            </div>

            <p className="ip-terms-section-content">
                You can contact us for any complaint resolution or further information about our services at <a href="mailto:Saranraj@Idealpursuits.co.in">Saranraj@Idealpursuits.co.in</a>.
            </p>
        </div>
    );
};

export default CareerCoachTerms;
